import { capitalize } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { InitiativeLink } from '../../../links/index.jsx';
import DateRange from './DateRange.jsx';
import InitiativeCompletion from './InitiativeCompletion.jsx';
import styles from './InitiativeRows.module.css';

InitiativeRows.propTypes = {
  initiatives: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      category: PropTypes.object.isRequired,
      completionTracked: PropTypes.bool,
      participationCount: PropTypes.number.isRequired,
      participationCompletedCount: PropTypes.number.isRequired,
      lead: PropTypes.string.isRequired,
      startDate: PropTypes.object.isRequired,
      endDate: PropTypes.object.isRequired,
    })
  ).isRequired,
};

function InitiativeRows({ hidden, initiatives, participantType }) {
  return initiatives.map((initiative, index) => {
    const isFirstRow = index === 0;
    const isLastRow = index === initiatives.length - 1;
    return (
      <tr
        className={`active ${styles.initiativeRow}`}
        key={`${initiative.type}${initiative.id}`}
        style={{ visibility: hidden ? 'collapse' : 'initial' }}
      >
        <td style={{ borderBottom: !isLastRow && 'none' }}>
          <h4 className={isFirstRow ? undefined : 'sr-only'}>
            {capitalize(initiative.type)}
          </h4>
        </td>
        <td>
          <h5>
            <InitiativeLink initiative={initiative}>
              <a>{initiative.title}</a>
            </InitiativeLink>
          </h5>
        </td>

        {initiative.category && (
          <td
            style={{ width: '180px' }}
            className={`${initiative.category.archived ? 'text-muted' : ''}`}
          >
            {initiative.category.name}
          </td>
        )}

        {participantType === 'Stakeholder' && (
          <React.Fragment>
            <td style={{ width: '180px' }}></td>
            <td style={{ width: '180px' }}></td>
          </React.Fragment>
        )}
        {participantType !== 'Stakeholder' && (
          <td>
            <InitiativeCompletion initiative={initiative} />
          </td>
        )}
        {/* <td> */}
        {/*  <InitiativeSentiment */}
        {/*    initiativeParticipation={initiative.initiativeParticipation} */}
        {/*  /> */}
        {/* </td> */}
        <td>{initiative.lead}</td>
        <td>
          <DateRange
            startDate={initiative.startDate}
            endDate={initiative.endDate}
          />
        </td>
      </tr>
    );
  });
}

export default InitiativeRows;
